import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-app-logo-name',
    templateUrl: './appLogoName.component.html',
    styleUrls: ['./appLogoName.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppLogoNameComponent {
  @Input() appName = 'eMeni';

}
